import clsx from 'clsx'
import React, {useContext} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {makeStyles} from 'external/material'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(buttonsStyles)

export default function Buttons (props) {

  const context = useContext(TeacherContext)
  const {onCancel, onCreate} = props
  const {translate} = context

  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Button
        variant="contained"
        className={clsx(classes.button, "create")}
        onClick={onCreate}>
          {translate('create')}
      </Button>
      <Button
        variant="contained"
        className={clsx(classes.button, "cancel")}
        onClick={onCancel}>
          {translate('cancel')}
      </Button>
    </Box>
  )
}

function buttonsStyles(theme) {

  return {
    root: {
      display: 'flex',
    },
    button: {
      width: 120,
      fontSize: "12pt",
      textTransform: "none",
      boxShadow: 'none',
      borderRadius: 4,
      "&:first-child": {
        marginRight: 10
      },
      "&:last-child": {
        marginLeft: 10
      },
      "&.cancel": {
        border: "solid 1px #3d4556",
        backgroundColor: '#fff',
        color: "#3d4556",
        '&:hover': {
          color: "#000",
          border: "solid 1px #000",
          backgroundColor: '#eaf5ff',
        },
      },
      "&.create" : {
        color: "#fff",
        border: 'solid 1px #1d9be5',
        backgroundColor: '#1d9be5',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#29739f',
          borderColor: '#29739f',
          boxShadow: 'none',
        },
      }
    },
  }
}
